import React from 'react';
import { compact } from 'lodash';
import { func, shape } from 'prop-types';
import { I18n, translate } from '@fiverr-private/i18n-react';
import TagsInput from '../../../../shared/TagsInput';
import { ONLY_LETTERS_NUMBERS_SPACES_REGEX } from '../../../../shared/TagsInput/constants';
import { LOCATION } from '../../../bi/mixpanel/constants';
import { BRIEF_DATA } from '../../../Listings/constants';
import { FILTER_MAX_TAGS_COUNT } from './constants';

// eslint-disable-next-line import/order
import commonClasses from '../shared/filter.module.scss';
import classes from './index.module.scss';

const TagsFilter = ({ briefData, setBriefData }) => (
    <div className={commonClasses.filterWrapper}>
        <label className={commonClasses.label}>
            <div className={commonClasses.caption}>
                <I18n k="variations_display.marketplace_listing.filters.tags.title" />
            </div>
            <TagsInput
                className={classes.tagsInput}
                onChange={(tags) => {
                    setBriefData(
                        { keywords: tags },
                        { location: LOCATION.STATIC }
                    );
                }}
                addOnBlur={true}
                validationRegex={ONLY_LETTERS_NUMBERS_SPACES_REGEX}
                tags={compact(briefData.keywords)}
                maxTags={FILTER_MAX_TAGS_COUNT}
                hideTags={true}
                placeholder={translate(
                    'variations_display.marketplace_listing.filters.tags.placeholder'
                )}
            />
        </label>
    </div>
);

TagsFilter.propTypes = {
    briefData: shape(BRIEF_DATA),
    setBriefData: func,
};

export default TagsFilter;
